import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import "./error.css";

export default function Error(props) {
  const { message, toggleError } = props;
  return (
    <div>
      <SweetAlert
        confirmBtnBsStyle="btn-hide"
        onConfirm={() => {}}
        title=""
        onCancel={() => {}}
      >
        <div className="errorModalContainer">
          <div className="errorModalMessage">
            {message}
            {" "}
          </div>
          <button type="button" className="migrateBtn" onClick={() => toggleError({ show: false, message: "" })}>
            Close
          </button>
        </div>
      </SweetAlert>
    </div>
  );
}
